import { Box, Grid2, Paper, Typography, Button } from "@mui/material";
import LinkButton from "../../components/buttons/linkButton.component";
import { Add } from "@mui/icons-material";
import FieldCard from "../../components/fieldCard/fieldCard.component";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFieldsStart } from "../../store/features/customer/fields/fieldsSlice";
import { useNavigate } from "react-router";
import CustomAlert from "../../components/alert/alert.component";
import { resetDeleteFieldState } from "../../store/features/customer/field/fieldSlice";
import FieldCardSkeleton from "../../components/skeletons/fieldCardSkeleton.component";
import FormActionButton from "../../components/buttons/formActionButton.component";
import { getActualCulture } from "../../utils/cultureUtils";
import { getFieldPmtilesUrl } from "../../utils/fieldMediaUtils";
import { getErrorMessage } from "../../utils/errorUtils";
import { ButtonStyles } from "../../styles/commonStyles";

const UserLandsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fieldsData = useSelector((state) => state.fields?.data?.data);
  const { success, error } = useSelector((state) => state.field);
  const { isLoading } = useSelector((state) => state.fields);
  const accessToken = useSelector((state) => state.auth?.user?.access_token);

  const handleAlertClose = () => {
    dispatch(resetDeleteFieldState());
  };

  useEffect(() => {
    dispatch(fetchFieldsStart({ accessToken }));
  }, [dispatch, accessToken]);

  return (
    <Box height="auto">
      {/* access to digital twin platform */}
      <Box
        width="100%"
        height="40px"
        display="flex"
        flexDirection="row"
        justifyContent="end"
        alignItems="center"
        gap={2}
        mt={2}
        mb={2}
      >
        {fieldsData && fieldsData.length > 0 ? (
          <>
            <Button
              variant="outlined"
              onClick={() => {
                navigate("/digitalTwin");
              }}
              sx={{
                ...ButtonStyles,
                textTransform: "none"
              }}
            >
              Entra in Digital Twin
            </Button>
            <LinkButton
              icon={<Add />}
              label="Nuovo terreno"
              href={"/userLands/addField"}
            />
          </>
        ) : undefined}
      </Box>

      <Grid2 container spacing={4} height="100%">
        {isLoading ? (
          Array.from({ length: 2 }).map((_, index) => (
            <Grid2 size={{ xs: 12, md: 6 }} key={index} mt={3}>
              <FieldCardSkeleton
                variant="rectangular"
                width="100%"
                height="442px"
              />
            </Grid2>
          ))
        ) : fieldsData && fieldsData?.length > 0 ? (
          fieldsData?.map((item) => (
            <Grid2 size={{ xs: 12, md: 6 }} key={item.id}>
              <FieldCard
                key={item.id}
                fieldName={item.name}
                fieldCulture={
                  getActualCulture(item?.field_colture)?.name ||
                  "Nessuna coltura attuale"
                }
                noteDate={item.noteDate || ""}
                noteText={item.noteText || ""}
                fieldPosition={item?.position}
                polygonCoordinates={item.polygon}
                pmtilesUrl={getFieldPmtilesUrl(item)}
                subAreas={item.field_parts || []}
                onClick={() => {
                  navigate(`${item.id}`);
                }}
              />
            </Grid2>
          ))
        ) : (
          <Paper
            sx={{
              paddingY: 2,
              paddingX: 4,
              width: "100%",
              overflowX: "auto",
              height: "100%",
            }}
            elevation={0}
          >
            <Box
              display="flex"
              width="100%"
              height="100%"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              gap={1}
            >
              <Typography fontSize="14px">
                Non hai ancora configurato nessuno terreno
              </Typography>
              <FormActionButton
                startIcon={<Add />}
                label="Nuovo terreno"
                onClick={() => navigate("/userLands/addField")}
              />
            </Box>
          </Paper>
        )}
      </Grid2>
      {success && (
        <CustomAlert
          severity="success"
          message="Terreno eliminato con successo"
          onClose={handleAlertClose}
        />
      )}
      {error && (
        <CustomAlert
          severity="error"
          message={getErrorMessage(error, {
            fallback: "Errore durante l'eliminazione del terreno",
          })}
          onClose={handleAlertClose}
        />
      )}
    </Box>
  );
};

export default UserLandsPage;
